module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "cabinet"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "cabinet-description"
    }
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      NOTRE CABINET\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row",
    attrs: {
      "id": "staff-content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6 col-xl-4 mb-4"
  }, [_c('figure', [_c('v-img', {
    attrs: {
      "id": "menu-logo",
      "src": "static/Equipe/img-1.jpg"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "flex-align-center col-12 row"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-xl-6 mb-4",
    attrs: {
      "id": "cabinet-images"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.cabinetImageURL,
      "height": "fit-content"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "col-12 font-style-highlight mb-3 underline"
  }, [_c('b', [_vm._v("Votre praticien")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figcaption', {
    staticClass: "staff-caption pt-1"
  }, [_c('div', {}, [_vm._v("Praticien conventionné, membre d'une Association de Gestion Agréée")]), _vm._v(" "), _c('div', [_vm._v("Inscription au tableau de l'Ordre n° 73709")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staff-member-section col-xs-12 col-lg-6 col-xl-8 pt-sm-3 row"
  }, [_c('h1', {
    staticClass: "col-12"
  }, [_vm._v("Dr SAAD Ryan")]), _vm._v(" "), _c('h2', {
    staticClass: "col-12 p-4 underline"
  }, [_vm._v("Cursus et expériences")]), _vm._v(" "), _c('ul', {
    staticClass: "col-12 row text-left"
  }, [_c('li', {
    staticClass: "col-12 mb-3"
  }, [_c('b', [_vm._v("Chirurgien-dentiste")]), _vm._v(", qualifié en "), _c('b', [_vm._v("Chirurgie Orale")])]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3 "
  }, [_c('b', [_vm._v("Ancien Interne")]), _vm._v(" des Hôpitaux en Chirurgie Orale ("), _c('b', [_vm._v("DES de Chirurgie Orale")]), _vm._v(")")]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3 "
  }, [_vm._v("Diplôme Universitaire en "), _c('b', [_vm._v("Implantologie Orale")]), _vm._v(" (Strasbourg)")]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3 "
  }, [_vm._v("Diplôme Universitaire en "), _c('b', [_vm._v("Esthétique du Sourire")]), _vm._v(" (Strasbourg)")]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3 "
  }, [_vm._v("Diplôme Universitaire en "), _c('b', [_vm._v("Chirurgie Pré et Péri-Implantaire")]), _vm._v(" (Paris XI)")]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3 "
  }, [_vm._v("Diplôme Universitaire d’"), _c('b', [_vm._v("Apnée du Sommeil")]), _vm._v(" (Paris)")]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3 "
  }, [_vm._v("Ancien attaché des Hôpitaux en Chirurgie Orale & d’enseignant dans différents Diplômes Universitaires et "), _c('b', [_vm._v("formations privées")])]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3"
  }, [_c('b', [_vm._v("Publications d’articles portant sur l’Implantologie & la Chirurgie Orale")]), _vm._v(" dans des revues internationales (European Journal Of Oral Implantology, Journal of Stomatology, Oral and Maxillofacial Surgery)")]), _vm._v(" "), _c('li', {
    staticClass: "col-12 mb-3"
  }, [_vm._v("Membre des "), _c('b', [_vm._v("Sociétés Scientifiques")]), _vm._v(" (SFCO, SFSCMFCO, AO)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "col-12 font-style-highlight mb-3 underline"
  }, [_c('b', [_vm._v("La structure")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-xl-6 p-5"
  }, [_c('div', {}, [_vm._v("\n             Le cabinet est situé au sein même de la Clinique Sainte-Geneviève au coeur du 14e arrondissement de Paris. Il dispose d'un accès pour personnes à mobilité réduite (PMR).\n            Il est constitué d’une "), _c('b', [_vm._v("salle de consultation")]), _vm._v(" et d’une "), _c('b', [_vm._v("salle blanche")]), _vm._v(" où se déroulent les interventions sous anesthésie locale.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n             Ainsi, votre intervention peut être réalisée sous "), _c('b', [_vm._v("anesthésie générale ")]), _vm._v(" ou sous "), _c('b', [_vm._v("sédation consciente")]), _vm._v(" au bloc opératoire, avec une prise en charge en ambulatoire ou une hospitalisation selon vos besoins.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 mt-4 pt-3 row"
  }, [_c('h2', {
    staticClass: "col-12 font-style-highlight mb-3 underline"
  }, [_c('b', [_vm._v("Aide Opératoire & Assistance")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-2"
  }, [_vm._v(" Toute notre équipe au sein de la Clinique Sainte-Geneviève est à votre service pour "), _c('b', [_vm._v("vous prendre en charge dans les meilleures conditions")]), _vm._v(". Des aides opératoires travaillent étroitement avec le praticien pour "), _c('b', [_vm._v("optimiser votre prise en charge")]), _vm._v(". Notre équipe sera également "), _c('b', [_vm._v("disponible pour vous aider dans les étapes administratives")]), _vm._v(" notamment pour les hospitalisations et chirurgies ambulatoires.")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-2 "
  }, [_vm._v(" Du fait des nombreuses formations et conférences auquel le praticien participe, "), _c('b', [_vm._v("avec votre consentement")]), _vm._v(", il se peut que des dentistes ou que votre propre dentiste observent l’intervention.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33e926a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33e926a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/cabinet/cabinet.component.html
// module id = 265
// module chunks = 1